import React, { useContext, useState } from "react";
import { withTranslation } from "react-i18next";
import SubstituteSelectorContext from "./SubstituteSelectorContext";
import RadioGroup from "./RadioGroup";
import ActionButtonGroup from "./ActionButtonGroup";
import "./SubstituteSelector.scss";

const OfficeSelectionStep = ({
  updateStep,
  isLoadingSubstitutes,
  removeFromSingleOffice,
  t,
}) => {
  const { text, onCancel } = useContext(SubstituteSelectorContext);
  const [selection, setSelection] = useState(removeFromSingleOffice ? 1 : 2);

  const radioOptions = [
    { value: 1, label: text.officeSelectionStep.option1 },
    { value: 2, label: text.officeSelectionStep.option2 },
  ];

  const handleNext = () => {
    updateStep(selection === 1);
  };

  return (
    <div>
      <p className="sss-description">
        {text.officeSelectionStep.description()}
      </p>

      <RadioGroup
        name="officeSelection"
        selectedValue={selection}
        onSelectionChange={setSelection}
        options={radioOptions}
      />

      <ActionButtonGroup
        primaryButtonKey="next"
        onPrimaryClick={handleNext}
        onCancel={onCancel}
        isLoading={isLoadingSubstitutes}
        isDisabled={isLoadingSubstitutes}
      />
    </div>
  );
};

export default withTranslation()(OfficeSelectionStep);
